import { Loader } from 'shared';

import { ResourceBankEmptyState } from 'features/resourceBank/components/EmptyState';
import { ResourceBankTable } from 'features/resourceBank/components/Table/Table';
import { useResourceBankQuery } from 'features/resourceBank/hooks/query';
import { useCoachId } from 'features/user/hooks/useCoachId';
import { useIsCoachMode } from 'features/user/hooks/useIsCoachMode';
import { useUserId } from 'features/user/hooks/useUserId';

export const Content = () => {
  const coachId = useCoachId();
  const participantId: string = useUserId();

  const isCoachMode = useIsCoachMode();

  const { data: sharedByResources = [], isFetching: isSharedByLoading } =
    useResourceBankQuery({
      shared_by_id: isCoachMode ? coachId : participantId,
      shared_to_id: isCoachMode ? participantId : coachId,
    });

  const { data: sharedToResources = [], isFetching: isSharedToLoading } =
    useResourceBankQuery({
      shared_by_id: isCoachMode ? participantId : coachId,
      shared_to_id: isCoachMode ? coachId : participantId,
    });

  if (isSharedToLoading || isSharedByLoading) {
    return <Loader />;
  }

  if (!sharedByResources.length && !sharedToResources.length) {
    return <ResourceBankEmptyState isDescriptionVisible={isCoachMode} />;
  }

  return (
    <>
      {sharedByResources.length > 0 ? (
        <ResourceBankTable
          resources={sharedByResources}
          title="Shared by you"
        />
      ) : null}
      {sharedToResources.length > 0 ? (
        <ResourceBankTable
          resources={sharedToResources}
          title="Shared with you"
        />
      ) : null}
    </>
  );
};
